module.exports = __webpack_public_path__ + "d38f7ac2c6425038eb90725ab0d2c467.svg";